<template>
    <KCard
        as="dl"
        variant="subtle"
        padding="sm"
        :class="block()"
    >
        <div
            v-for="(item, index) in items"
            :key="`${item.label}-${index}`"
            :class="element('item')"
        >
            <KEyebrow
                as="dt"
                :class="element('label')"
            >
                {{ item.label }}
            </KEyebrow>
            <dd :class="element('value')">
                {{ item.value }}
            </dd>
        </div>
    </KCard>
</template>

<script setup lang="ts">
import type { KFactListProps } from './types'
import useBem from '@yeeroen/use-bem'

import KCard from '../card/k-card.vue'
import KEyebrow from '../eyebrow/k-eyebrow.vue'

defineOptions({ name: 'KFactList' })

defineProps<KFactListProps>()

const { block, element } = useBem('k-fact-list')
</script>

<style lang="scss">
@use './k-fact-list.scss';
</style>
